import { render, staticRenderFns } from "./payrollitemedit.vue?vue&type=template&id=4a5dff4c&scoped=true"
import script from "./payrollitemedit.vue?vue&type=script&lang=js"
export * from "./payrollitemedit.vue?vue&type=script&lang=js"
import style0 from "./payrollitemedit.vue?vue&type=style&index=0&id=4a5dff4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5dff4c",
  null
  
)

export default component.exports